/**
 * 小程序二维码数据。
 * 区分postType。
 * home,savePoster,poserList
 */
const mixin_qrcode_miniProgram = {
  data () {
    return {
      postType: 3, // 0: 默认；1:个性；3: 面对面
      qrcode_miniProgram: '' // 微信小程序二维码
    }
  },
  methods: {
    // 设置微信小程序二维码
    async setQRCode (postType, isShowToast, posterId = '') {
      const tutorId = this.tutorId || ''
      if (!this.userInfo) {
        if (isShowToast) return this.$toast.fail({ message: '请登录后再进入页面', duration: 0 })
        return
      }
      const userId = this.userInfo.uid
      return this.$api.getMiniAppQRcode(tutorId, userId, window._wltfChannel.hotUrlParams.source || window._wltfChannel.urlParmas.source_id || '', postType, posterId).then(result => {
        this.qrcode_miniProgram = result
        sessionStorage.setItem(`ldxQRCode_miniProgram_${postType}`, result)
        return result
      }).catch(e => { console.error('get MiniApp QRcode', e); return false })
    }
  }
}
/**
 * 分享成功奖励数据.
 * SharePanel(home,rewardpage,courseexchange)
 * emit(shareReward). Home需要更新分享次数
 */
const mixin_shareReward = {
  data () {
    return {
      shareSuccForGold_max: 3, // 分享成功获得金币 最多次数
      shareSuccForGold_count: 0, // 分享成功获得金币 当期次数
      shareSuccForGold_gold: 100 // 每次分享成功获得金币 额度
    }
  },
  mounted () {
    this.getShareCountForGold()
  },
  methods: {
    // 分享成功后，增加分享可获得金币的次数
    async increaseShareCountForGold () {
      // 每月最多三次；接口调用和提示次数都做限制 用户分享后，最少会弹一次告诉用户已经获得300金（初始化得不到session数据）
      if (this.shareSuccForGold_count >= this.shareSuccForGold_max) return
      const result = await this.$api.increaseShareCountForGold()
      const { code, data } = result
      if (code !== 0) return
      const shareNum = data.shareNum
      this.shareSuccForGold_count = shareNum
      this.$toast(`恭喜您分享成功，已经获得${shareNum * this.shareSuccForGold_gold}金币`)
      // 首页需要更新数据展示
      this.$store.dispatch('changeShareCountForGold', shareNum)
    },
    getShareCountForGold () {
      this.$api.getShareCountForGold().then(result => {
        const { code, data = {} } = result
        if (code !== 0) return
        const shareNum = data.shareNum || 0
        this.$store.dispatch('changeShareCountForGold', shareNum)
        this.shareSuccForGold_count = shareNum
      })
    }
  }
}
/**
 * 分享时需要设置的参数。
 * 包括：link，userId，qrcode，poseterData等
 * home，rewardpage，courseExchange 都有分享
 */
const mixin_shareData = {
  data () {
    return {
      // 分享数据
      shareData: {
        userId: '', qrcode: '', posterData: null
      },
      // 分享基本配置
      shareConfig: {
        link: '', // h5 页面链接
        title: '好友邀你上名师课，购课立减200元！', // 分享标题
        desc: '清北哈佛毕业名师，十余年教学经验，让孩子每天进步一点点！', // 分享描述
        imgUrl: 'https://activity.xueersi.com/topic/growth/common/images/common/xes-logo.png' // 分享图标
      }
    }
  },
  async created () {
    if (this.userInfo) {
      this.shareData.userId = this.userInfo.uid
    }
  },
  mounted () {
    this.setShareData()
  },
  methods: {
    /**
     * 获取(设置) 邀请/分享 时的数据。
     * 主要是邀请短链接，海报数据.
     * 如果微信环境，设置微信分享的链接。
     */
    async setShareData () {
      // 如果设置过分享数据则跳过，没有的话去获取数据。
      const result = await this.$api.getShareData()
      const { code, data } = result
      if (code !== 0) return
      this.shareData.posterData = data // rewardPage
      this.shareConfig.link = data.inviteUrl // courseExchange
      this.getShareUrl()
    },
    async getShareUrl () {
      const params = {
        source_id: window._wltfChannel.hotUrlParams.source || window._wltfChannel.urlParmas.source_id || ''
      }
      if (this.tutorId) {
        params.teacherId = this.tutorId
      }
      const result = await this.$api.getPosterData(params)
      const { code, data } = result
      if (code !== 0) return
      this.shareConfig.link = data.inviteUrl // courseExchange
    }
  }
}
export { mixin_qrcode_miniProgram, mixin_shareData, mixin_shareReward }
